import { render } from "./EditList.vue?vue&type=template&id=416f3d22"
import script from "./EditList.vue?vue&type=script&lang=js"
export * from "./EditList.vue?vue&type=script&lang=js"
script.render = render

export default script